import React from 'react';
import { Text, StyleSheet, TouchableOpacity } from 'react-native';
import { AntDesign } from '@expo/vector-icons';

const CleanNowCard = ({ cleanNow }) => {
  return (
    <TouchableOpacity
      style={styles.cleanNowBox}
      onPress={cleanNow}
      activeOpacity={0.85}
    >
      <Text style={styles.cleanNowText}>CLEAN NOW</Text>
      <AntDesign name="arrowright" size={24} color="white" />
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  cleanNowBox: {
    minHeight: 60,
    backgroundColor: '#2563eb',
    borderRadius: 18,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingHorizontal: 18,
    marginTop: 8,
    shadowColor: '#0f172a',
    shadowOpacity: 0.1,
    shadowOffset: { width: 0, height: 14 },
    shadowRadius: 24,
    elevation: 4,
  },
  cleanNowText: {
    color: '#fff',
    fontWeight: '800',
    fontSize: 16,
    letterSpacing: 0.5,
  },
});

export default React.memo(CleanNowCard);